import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './filters'
import { WPSettings } from '@/WPSettings'

// @ts-ignore
import VBodyScrollLock from 'v-body-scroll-lock'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format'
import VueI18n from 'vue-i18n'
import translationsNL from './translations/translations.nl'
import translationsEN from './translations/translations.en'
import translationsFR from './translations/translations.fr'
import translationsDE from './translations/translations.de'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: WPSettings.LANGUAGE,
  fallbackLocale: 'nl',
  messages: {
    nl: translationsNL,
    en: translationsEN,
    fr: translationsFR,
    de: translationsDE
  }
})

Vue.use(VBodyScrollLock)
Vue.use(VueFilterDateFormat)

require('@/styles/main.scss')

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#imot-app')
